import { Clipboard } from '@capacitor/clipboard';
import { useIonToast } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';

export const useClipboard = () => {
  const [presentToast] = useIonToast();
  const { isMobileView } = useWindowDimensions();

  const copy = (value: string, message: string) => {
    Clipboard.write({
      string: value
    }).then(() => {
      presentToast({
        message: message,
        duration: 2000,
        icon: checkmark,
        position: isMobileView ? 'bottom' : 'top',
        color: 'success'
      });
    });
  };

  return {
    copy
  };
};
